import { defineComponent as _defineComponent } from 'vue'


interface Props {
	/**
	 * トークルーム内容。
	 */
	contents: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    contents: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * トークルーム内容。
	 */
	contents: string;
}
/**
 * トークルーム情報 > 投稿内容。
 */



const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})